<div class="container">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Push Nachricht bearbeiten </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="editForm">
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Typ:</mat-label>
                                <mat-select formControlName="type">
                                    <mat-option *ngFor="let sortOption of typesOfPushMessages"
                                        [value]="sortOption.value" [disabled]="sortOption.state">
                                        {{sortOption.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="editForm.get('type').hasError('required')">
                                    Typ <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Aktion:</mat-label>
                                <mat-select formControlName="eventID">
                                    <mat-option *ngFor="let sortOption of options"
                                        [value]="sortOption.value" [disabled]="sortOption.state">
                                        {{sortOption.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="editForm.get('eventID').hasError('required')">
                                    Aktion <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Text:</mat-label>
                                <textarea formControlName="text" matInput rows="8" cols="50"></textarea>
                                <mat-error *ngIf="editForm.get('text').hasError('required')">
                                    Text <strong>muss</strong> angegeben werden
                                </mat-error>
                                <mat-error *ngIf="editForm.get('text').hasError('maxlength')">
                                    Maximal 1024 Zeichen
                                </mat-error>
                                <mat-hint>Auf iOS Geräten wird die Nachricht auf ca. 110 Zeichen gekürzt.
                                </mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row" >
                        <div class="col-sm-8">
                            <mat-form-field class="full-width">
                                <mat-label>Datum:</mat-label>
                                <input matInput formControlName="date" type="date">
                                <mat-error *ngIf="editForm.get('date').hasError('required')">
                                    Datum <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-4">
                            <mat-form-field class="full-width">
                                <mat-label>Uhrzeit:</mat-label>
                                <input matInput formControlName="time" type="time">
                                <mat-error *ngIf="editForm.get('time').hasError('required')">
                                    Uhrzeit <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>

                    </div>

                    <div class="row" *ngIf="this.currentPush?.send != null">
                        <div class="col-sm-8">
                            <mat-form-field class="full-width">
                                <mat-label>Gesendet Am:</mat-label>
                                <input matInput formControlName="send_date" type="date">
                            </mat-form-field>
                        </div>

                        <div class="col-sm-4">
                            <mat-form-field class="full-width">
                                <mat-label>Gesendet Am:</mat-label>
                                <input matInput formControlName="send_time" type="time">
                            </mat-form-field>
                        </div>

                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" [routerLink]="['../']">Abbrechen</button>
                    <button mat-button color="primary" (click)="editPush()" [disabled]="isInPast || !this.editForm.dirty">Änderungen Speichern</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
</div>